import styled from 'styled-components'
import { Flex } from 'components/Box'
import React, { forwardRef } from 'react'

const Wrapper = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  background-color: rgba(0, 0, 0, 0.65);
  color: ${({ theme }) => theme.colors.text.light.base};
  border-radius: 50%;

  > * {
    user-select: none;
  }
`

interface AvatarContainerProps {
  children: React.ReactNode
}

const AvatarContainer = forwardRef<HTMLDivElement, AvatarContainerProps>(
  ({ children, ...props }, forwardedRef) => (
    <Wrapper ref={forwardedRef} {...props}>
      <Flex height="100%" justifyContent="center" alignItems="center">
        {children}
      </Flex>
    </Wrapper>
  )
)

AvatarContainer.displayName = 'AvatarContainer'

export default AvatarContainer
